import { jsxs as v, jsx as i } from "react/jsx-runtime";
import { useRef as s, useEffect as u } from "react";
import { Container as E, Button as h, PopoverContainer as k } from "./styles.js";
const x = ({
  children: a,
  content: l,
  isOpen: o,
  setIsOpen: t,
  onClick: c,
  popoverContainerStyle: f,
  ...m
}) => {
  const n = s(null), d = s(null);
  return u(() => {
    const e = (r) => {
      d.current && !d.current.contains(r.target) && n.current && !n.current.contains(r.target) && t(!1);
    };
    return document.addEventListener("mousedown", e), () => {
      document.removeEventListener("mousedown", e);
    };
  }, [o, n, t]), u(() => {
    const e = (r) => {
      r.key === "Escape" && t(!1);
    };
    return document.addEventListener("keydown", e), () => {
      document.removeEventListener("keydown", e);
    };
  }, [t]), /* @__PURE__ */ v(E, { children: [
    /* @__PURE__ */ i(h, { onClick: (e) => {
      t(!o), c == null || c(e);
    }, ref: d, ...m, children: a }),
    o && /* @__PURE__ */ i(
      k,
      {
        $extendesStyle: f,
        ref: n,
        children: l
      }
    )
  ] });
};
export {
  x as Popover
};
